/**
 * Structured-tab palette — every color comes from src/theme/colors.js.
 */
import colors, { slate, status, steel, teal } from "../../../../../../../theme/colors";

export const TONES = {
  ok: { fg: status.success.fg, bg: status.success.bg, solid: status.success.solid },
  warn: { fg: status.warning.fg, bg: status.warning.bg, solid: status.warning.solid },
  crit: { fg: status.error.fg, bg: status.error.bg, solid: status.error.solid },
  neutral: { fg: slate[600], bg: slate[100], solid: slate[500] },
  accent: { fg: teal[700], bg: teal[100], solid: teal[500] },
  // "Soft cost" and similar secondary classifications — steel, the product's
  // second accent (colors.js), rather than a new purple.
  purple: { fg: steel.main, bg: steel.tint, solid: steel.main },
  muted: { fg: slate[500], bg: slate[100], solid: slate[400] },
};

export const toneOf = (t) => TONES[t] || TONES.neutral;

export const BREAKDOWN = { primary: teal[500], secondary: steel.main, tertiary: slate[300] };

export const MONO = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";

export const LINE = slate[200];
export const LINE_SOFT = slate[100];
export const SURFACE = slate[50];
export const INK = colors.slate900;
export const SUB = slate[500];
export const FOCUS_RING = { outline: `2px solid ${teal[300]}`, outlineOffset: "2px" };

/**
 * The app font (theme typography — "Inter", …) on a container, forced onto its
 * buttons and inputs too: <button>/<input> don't inherit font-family from the
 * page and ButtonBase / InputBase don't set one, so table rows, group headers,
 * toggles and pills would otherwise fall back to the system font.
 */
export const APP_FONT = {
  fontFamily: (theme) => theme.typography.fontFamily,
  "& button, & input, & textarea": { fontFamily: "inherit" },
};

/** Stable DOM id for a data path (spec §6.1). */
export const domId = (path) => `sv-${String(path).replace(/[^A-Za-z0-9]+/g, "-")}`;
export const sectionDomId = (id) => `sv-section-${String(id).replace(/[^A-Za-z0-9]+/g, "-")}`;

/** Keyframes: accent flash (goTo) and amber focus (focusField). */
export const flashSx = {
  "@keyframes svFlash": {
    "0%": { backgroundColor: teal[100] },
    "100%": { backgroundColor: "transparent" },
  },
  "&[data-flash='flash']": { animation: "svFlash 1.4s ease-out" },
  "&[data-flash='focus']": {
    backgroundColor: status.warning.bg,
    boxShadow: `inset 3px 0 0 ${status.warning.solid}`,
  },
  "@media (prefers-reduced-motion: reduce)": {
    "&[data-flash='flash']": { animation: "none", backgroundColor: teal[50] },
  },
};

/** Row tools: shown on hover, always on touch / narrow screens. */
export const toolsSx = {
  "& .sv-tools": { opacity: 0, transition: "opacity .12s" },
  "&:hover .sv-tools, &:focus-within .sv-tools": { opacity: 1 },
  "@media (hover: none), (max-width: 820px)": { "& .sv-tools": { opacity: 1 } },
};
